<template>
  <div class="markdown-visualizer" v-html="renderedHtml"></div>
</template>

<script>
export default {
  name: 'MarkdownVisualizer',
  props: {
    text: {
      type: String,
      default: ''
    },
    mentionItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    renderedHtml() {
      if (!this.text) return '';

      let html = this.text;

      // Parse mentions @[Name](id)
      html = html.replace(/@\[([^\]]+)\]\(([^)]+)\)/g, (match, label, id) => {
        let avatarHtml = `<span class="mention-fallback">${label.charAt(0).toUpperCase()}</span>`;

        const item = this.mentionItems.find(m => String(m.id) === String(id));
        if (item && item.image) {
          avatarHtml = `<img src="${item.image}" class="mention-avatar" alt="${label}" />`;
        }

        return `<span class="mention" data-mention-id="${id}" title="${label}">
            ${avatarHtml}@${label}
        </span>`;
      });

      // Parse bold
      html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>'); // standard markdown **bold**
      html = html.replace(/(^|\s)\*([^*]+)\*(\s|$)/g, '$1<strong>$2</strong>$3'); // whatsapp *bold*

      // Parse italic
      html = html.replace(/(^|\s)_([^_]+)_(\s|$)/g, '$1<em>$2</em>$3');

      // Parse strike
      html = html.replace(/(^|\s)~([^~]+)~(\s|$)/g, '$1<del>$2</del>$3');

      // Convert line breaks to <br>
      html = html.replace(/\n/g, '<br>');

      return html;
    }
  },
  methods: {
    escapeHtml(unsafe) {
      return (unsafe || '')
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }
  }
}
</script>

<style scoped>
.markdown-visualizer {
  word-break: break-word;
  white-space: normal;
  line-height: 1.5;
}

.markdown-visualizer>>>strong {
  font-weight: 700;
}

.markdown-visualizer>>>em {
  font-style: italic;
}

.markdown-visualizer>>>del {
  text-decoration: line-through;
  opacity: 0.8;
}

.markdown-visualizer>>>.mention {
  font-family: inherit;
  background-color: #edfcf3;
  color: var(--primary, #0b9055);
  border-radius: 9999px;
  padding: 2px 6px 2px 2px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  vertical-align: middle;
  font-weight: 500;
  font-size: 13px;
}

.markdown-visualizer>>>.mention-avatar {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  object-fit: cover;
}

.markdown-visualizer>>>.mention-fallback {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #e5e7eb;
  color: #374151;
  font-size: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}
</style>
